<template>
    <vf-button
        is-cta
        class="vf-moderation__control vf-label-text"
        :class="buttonClasses"
        :is-inverted="isInverted"
        :palette="palette"
        :disabled="disabled"
        :size="size"
    >
        <slot>
            <span class="vf-ellipsis-overflow">
                {{ text }}
            </span>
        </slot>
    </vf-button>
</template>

<script>
import { PALETTES, SIZES } from 'design-assets/components/buttons/constants.js';
import { vfButton } from 'design-assets/components/buttons/buttons.c.js';
import VueTypes from 'commons/util/vue-types.js';

export default {
    props: {
        text: VueTypes.string,
        size: VueTypes.string.def(SIZES.SMALL),
        palette: VueTypes.string.def(PALETTES.ACCENT),
        disabled: VueTypes.bool.def(false),
        isInverted: VueTypes.bool,
        isLong: VueTypes.bool.def(false),
    },

    computed: {
        buttonClasses() {
            return {
                'vf-moderation__control--long': this.isLong,
            };
        },
    },

    components: {
        vfButton,
    },
};
</script>

<style scoped lang="scss">
@import "~design-assets/css/variables/module.scss";

.vf-moderation__control--long {
    min-width: 120px;
}

.vf-moderation__control.is-cta.is-inverted:not([disabled]) {
    @include var(background-color, 'default-color-0');
}
</style>
